// angular
import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

// addons
import { Observable } from 'rxjs';

// store
import { Store, select } from '@ngrx/store';
import * as fromStore from '@store/index';

// models
import { IToast } from '@shared/models';

@Component({
  selector: '[v-root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  toasts$: Observable<{[id: string]: IToast}>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private store: Store<fromStore.State>
  ) {
    this.toasts$ = this.store.pipe(select(fromStore.UiSelectors.getToasts));
  }

  ngAfterViewInit() {
    this.handleAppInitialazeAnimation();

    // This is obviously horrible and needs to be removed when proper cache is implemented
    if (window.location.href.substring(window.location.href.lastIndexOf('/')).includes('/setpassword')) {
      return;
    } else if (window.location.href.substring(window.location.href.lastIndexOf('/')).includes('/forgot')) {
      return;
    } else if (window.location.href.substring(window.location.href.indexOf('/')).includes('/recovery')) {
      return;
    }

    this.store.dispatch(fromStore.UserActions.getCache());
  }

  handleAppInitialazeAnimation() {
    const loaderBackground = this.document.querySelector('.c-app-loader-backgound');
    const loaderLogo = this.document.querySelector('.c-app-loader-logo');

    loaderBackground.addEventListener('transitionend', () => {
      loaderBackground.remove();
      loaderLogo.remove();
    });

    loaderLogo.addEventListener('transitionend', () => {
      loaderBackground.classList.add('fade-out');
    });

    loaderLogo.classList.add('fade-out');
  }
}

